module.exports = __webpack_public_path__ + "img/21.6318d32c.png";